import {Component, OnInit, ViewChild} from '@angular/core';
import {DatePipe, Location} from '@angular/common';
import {User} from '../../../dto/user';
import {ReplaySubject, Subject} from 'rxjs';
import {FormControl} from '@angular/forms';
import {UserTimeLineByDate} from '../../../dto/user-location/user-timeline-by-date';
import {Point} from '../../../dto/user-location/point';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import * as L from 'leaflet';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {BaseService} from '../../../services/base.service';
import {ActivatedRoute} from '@angular/router';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';
import {AuthService} from '../../../services/auth.service';
import {MarketService} from '../../../services/market.service';
import {debounceTime, takeUntil} from 'rxjs/operators';
import swal from 'sweetalert2';
import {base_urls} from '../../../config/base_urls';
import {Event} from '../../../dto/user-location/event';
import {prepareObject} from '../../../services/utilities';
import {Endpoints} from '../../../config/endpoints';

@Component({
  selector: 'app-user-timeline-by-date-range',
  templateUrl: './user-timeline-by-date-range.component.html',
  styleUrls: ['./user-timeline-by-date-range.component.scss']
})
export class UserTimelineByDateRangeComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;
    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    timelineList: UserTimeLineByDate[] = [];
    filteredTimelineList: UserTimeLineByDate[] = [];
    listDataSource: Point[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    displayedColumns = ['SN', 'From', 'To', 'Address', 'Duration', 'Distance'];
    lineColors: string[] = ['mediumseagreen', 'deepskyblue', 'gray', 'navy', 'yellow', 'orange', 'purple', 'cyan', 'magenta', 'lime'];
    imeiList: any[] = [];
    selectedImei: string;
    tabList = ['Timeline', 'Map'];
    userRank: number;
    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];
    marketIndex = 0;
    map: L.Map;
    polyLineLayer: L.LayerGroup = L.layerGroup();
    markerLayerGroup: L.LayerGroup = L.layerGroup();
    selectedTab = 'Timeline';
    customStyle = [
        {
            'featureType': 'landscape',
            elementType: 'geometry',
            'stylers': [
                {'hue': '#37cb37'},
                {'saturation': -20},
                {'lightness': -8}
            ]
        }
    ];

    userId: number;
    userCode: string;
    filters = {
        'userId': null,
        fromDate: moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        toDate: moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        fileType: null
    };

    isCalenderOpen = false;
    fromDate = moment();
    toDate = moment();
    moment = moment;
    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null, endDate: null};
    datePipe = new DatePipe('en-US');

    mapTimelineList: UserTimeLineByDate[] = [];

    isAdmin = false;
    eventList = new Event();

    private _unsubscribeAll: Subject<any>;
    @ViewChild(DaterangepickerDirective, {static: true}) dateRangePicker: DaterangepickerDirective;

    constructor(private service: BaseService, private router: ActivatedRoute, private generalBroadcastService: GeneralBroadcastService,
                private auth: AuthService, private marketService: MarketService,
                private route: ActivatedRoute,
                private location: Location) {

        this._unsubscribeAll = new Subject();
        this.loggedUser = this.auth.user;
        this.isAdmin = this.auth.hasAccess('ADMIN', 'ADMIN_ACCESS');

        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();
        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };
        this.ranges = {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
            ],
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
        this.selectedRange.endDate = moment().subtract(0, 'days').startOf('day');
        this.generalBroadcastService.broadcastSelectedModuleId('LOCATION');
        this.generalBroadcastService.broadcastTitle('User Timeline By Date Range');
    }

    ngOnInit(): void {
        // this.map = L.map('map').setView([23.8383283, 90.3759853], 7);
        // L.gridLayer.googleMutant({
        //     type: 'roadmap',
        //     styles: this.customStyle
        // }).addTo(this.map);
        this.router.queryParams.subscribe(params => {
            if (params.userCode) {
                this._getUserList(params.userCode);
                this.userCode = params.userCode;
            } else {
                this._getUserList();
            }
            if (params.userId) {
                this.filters.userId = Number(params.userId);
                this.userId = Number(params.userId);
            }
            if (params.date) {
                this.filters.fromDate = params.date;
                this.filters.toDate = params.date;
                this.selectedRange.startDate = moment(params.date);
                this.selectedRange.endDate = moment(params.date);
            }
            if (params.date) {
                this.getLocationList();
            }
            this.selectedTab = 'Map';
            this.loadMapIfNeeded();

        });
        this.userFilter.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

    }

    loadMapIfNeeded(): void {
        if (this.selectedTab !== 'Map') {
            return;
        }

        if (!this.filters.userId) {
            this.initializeMap();
            return;
        }

        this.selectedImei = null;
        this.loadingData = true;

        this.service.getUserTimelineByDateRange(this.filters, base_urls.p_base)
            .subscribe(locationList => {

                this.loadingData = false;

                const dateImeiDataList = locationList[0].dateImeiDataList || [];

                if (!dateImeiDataList.length) {
                    this.timelineList = [];
                    this.mapTimelineList = [];
                    this.filteredTimelineList = [];
                    return;
                }

                this.timelineList = dateImeiDataList;
                this.filteredTimelineList = dateImeiDataList;
                this.mapTimelineList = dateImeiDataList;

                setTimeout(() => {
                    this.initializeMap();
                    this.prepareMapData();
                    this.map.invalidateSize();
                }, 100);
            });
    }

    initializeMap(): void {
        if (this.map) {
            this.map.remove();
        }

        this.map = L.map('map').setView([this.lat, this.lng], 7);

        L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: this.customStyle
        }).addTo(this.map);

        this.polyLineLayer = L.layerGroup().addTo(this.map);
        this.markerLayerGroup = L.layerGroup().addTo(this.map);
    }

    viewInMap(index: number): void {

        const selectedDateData = this.timelineList[index];
        this.mapTimelineList = [selectedDateData];

        this.selectedTab = 'Map';

        setTimeout(() => {
            this.initializeMap();
            this.prepareMapData();
            this.map.invalidateSize();
        }, 100);
    }

    dateChangeListener(pEvent: any): void {
        this.filters.fromDate = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.filters.toDate = this.datePipe.transform(this.selectedRange.endDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
        if (pEvent.startDate != null && pEvent.endDate != null) {
            this.getLocationList();
        }
    }


    compareUsers(pUser1: number, pUser2: number): boolean {
        return pUser1 && pUser2 && pUser1 == pUser2;
    }

    saveNavigation(): void {
        const hasQueryParams = this.userCode || this.userId;
        const convertedQueryParams = `?userCode=${this.userCode}&userId=${this.userId}`;
        const baseUrl = this.location.path().split('?')[0];
        this.location.replaceState(`${baseUrl}${hasQueryParams ? convertedQueryParams : ''}`);
    }

    clearMapData(): void {
        this.userId = null;
        this.userCode = null;
        this.filteredTimelineList = [];
        this.timelineList = [];
        this.mapTimelineList = [];
        this.imeiList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.filters.userId = null;
        this.saveNavigation();
    }

    resetParameters(): void {
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.selectedMarket[i] = null;
            }
        }
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    interpolatePoints(start: [number, number], end: [number, number]): [number, number][] {
        const points: [number, number][] = [];
        const totalPoints = Math.ceil((this.calculateDistance(start, end) / 40) * 0.5);
        for (let i = 1; i <= totalPoints; i++) {
            const lat = start[0] + ((end[0] - start[0]) / (totalPoints + 1)) * i;
            const long = start[1] + ((end[1] - start[1]) / (totalPoints + 1)) * i;
            points.push([lat, long]);
        }

        return points;
    }

    calculateAngle(point1: [number, number], point2: [number, number]): number {
        const lat1 = point1[0];
        const long1 = point1[1];
        const lat2 = point2[0];
        const long2 = point2[1];

        const angleRad = Math.atan2(long2 - long1, lat2 - lat1);
        const angleDeg = angleRad * (180 / Math.PI);
        return angleDeg - 90;
    }

    calculateDistance(point1: [number, number], point2: [number, number]): number {
        const [lat1, lon1] = point1;
        const [lat2, lon2] = point2;

        const toRadians = (degrees: number) => degrees * (Math.PI / 180);

        const R = 6371;
        const dLat = toRadians(lat2 - lat1);
        const dLon = toRadians(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c * 100;
    }

    getLocationList(): void {
        if (!this.filters.userId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }

        this.selectedImei = null;
        this.loadingData = true;
        this.service.getUserTimelineByDateRange(this.filters, base_urls.p_base).subscribe(locationList => {
            this.loadingData = false;
            const dateImeiDataList = locationList[0].dateImeiDataList || [];
            console.log(dateImeiDataList);

            this.listDataSource = dateImeiDataList
                .flatMap(item => item.points || []);
            if (dateImeiDataList.length > 0) {
                this.timelineList = dateImeiDataList;
                this.filteredTimelineList = dateImeiDataList;
                this.lat = dateImeiDataList[0].points[0].latitude;
                this.lng = dateImeiDataList[0].points[0].longitude;
                this.listDataSource = dateImeiDataList.map(pItem => pItem.points).reduce((acc, points) => acc.concat(points), []);
                this.imeiList = dateImeiDataList.map(pItem => ({Imei: pItem.imei, Device: pItem.deviceModel}));

                this.mapTimelineList = dateImeiDataList;
                setTimeout(() => {
                    this.initializeMap();
                    this.prepareMapData();
                    if (this.map) {
                        this.map.invalidateSize();
                    }
                }, 100);
            } else {
                this.timelineList = [];
                this.filteredTimelineList = [];
                this.imeiList = [];
                this.mapTimelineList = [];
                if (this.polyLineLayer) {
                    this.polyLineLayer.clearLayers();
                }
                if (this.markerLayerGroup) {
                    this.markerLayerGroup.clearLayers();
                }
            }
        }, error => {
            this.loadingData = false;
        });
    }

    imeiChangeListener(): void {
        if (this.selectedImei) {
            this.filteredTimelineList = this.timelineList.filter(pItem => pItem.imei == this.selectedImei);
        } else {
            this.filteredTimelineList = this.timelineList;
        }
        this.mapTimelineList = this.filteredTimelineList;
        this.prepareMapData();
        this.listDataSource = this.filteredTimelineList.map(pItem => pItem.points).reduce((acc, points) => acc.concat(points), []);
    }

    prepareMapData(): void {
        let timeLineInfo = [];
        let coOrdsList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.mapTimelineList.forEach((pTimeLine, pTimeLineIndex) => {
            timeLineInfo = pTimeLine.points
                .filter(pData => pData.latitude > 0 && pData.longitude > 0)
                .map((
                    {
                        latitude: pLatitude,
                        longitude: pLongitude,
                        fromTime: pFromTime,
                        tillTime: pTillTime,
                        address: pAddress,
                        durationStr: pDurationStr,
                        duration: pDuration,
                        distance: pDistance,
                        distanceStr: pDistanceStr,
                        speedFromPreviousPointStr: pSpeedFromPreviousPointStr,
                    }) => ({
                    fromTime: pFromTime,
                    tillTime: pTillTime,
                    address: pAddress,
                    durationStr: pDurationStr,
                    duration: pDuration,
                    distance: pDistance,
                    distanceStr: pDistanceStr,
                    speedFromPreviousPointStr: pSpeedFromPreviousPointStr,
                    coOrds: [pLatitude, pLongitude],
                }));
            const currentCoOrdsList = timeLineInfo.map(pItem => pItem.coOrds);
            coOrdsList = [...coOrdsList, ...currentCoOrdsList];
            
            const currentPolyline = L.polyline(currentCoOrdsList, {
                color: this.lineColors[this.selectedImei ? this.imeiList.findIndex(pImei => pImei.Imei == this.selectedImei) : pTimeLineIndex],
                weight: 15,
                opacity: 1,
                lineCap: 'round'
            });
            this.polyLineLayer.addLayer(currentPolyline);
            let customIcon = null;

            timeLineInfo.forEach((pItem, pIndex) => {

                const backgroundColor = pItem.duration > 0 ? 'red' : 'white';
                const textColor = pItem.duration > 0 ? 'white' : 'black';
                const borderColor = pItem.duration > 0 ? 'white' : 'black';
                const height = pIndex < 99 ? '20px' : '25px';
                const width = pIndex < 99 ? '20px' : '25px';
                if (pIndex != 0 && pIndex < timeLineInfo.length - 1) {
                    customIcon = L.divIcon({
                        html: `<div style="display: flex; align-items: center; justify-content: center; height: ${height}; width: ${width}; font-size: 12px; 
                                        background: ${backgroundColor}; 
                                        color: ${textColor}; 
                                        border: 1px solid ${borderColor}; 
                                        border-radius: 50%">${pIndex + 1}</div>`,
                        iconSize: pIndex < 99 ? [20, 20] : [25, 25],
                        iconAnchor: pIndex < 99 ? [10, 20] : [12.5, 25],
                        className: ''
                    });
                } else if (pIndex == 0) {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_start.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });

                } else {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_current.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });
                }

                const marker = L.marker(pItem.coOrds, {icon: customIcon})
                    .bindPopup(
                        `
                        <div style="display: flex; flex-direction: column; gap: 10px">
                            <div style="color: #737373; font-weight: bold; font-size: 15px">${pIndex + 1}.</div>
                            <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; gap: 10px">
                                <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; flex-direction: row; gap: 2px; margin-left: 2px">
                                    <img style="height: 16px; width: 16px;" src="/assets/icons/location-icons/clock-2.svg">
                                    <div style="color: #737373; font-weight: bold">${this.datePipe.transform(pItem.fromTime, 'hh:mm a')} to ${this.datePipe.transform(pItem.tillTime, 'hh:mm a')} </div>
                                </div>
                                <div style="font-size: 12px; font-family: Muli; display: flex; flex-direction: row; align-items: center; gap: 2px">
                                    <div style="height: 5px; width: 5px; border-radius: 50%; background-color: #737373"></div>
                                    <div style="color: #737373; font-weight: bold">${pItem.durationStr ? pItem.durationStr : 'Travelling'}</div>
                                </div>   
                             </div>
                            <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 2px;">
                                <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/gauge.svg">
                                <div style="color: #737373; font-weight: bold">${pItem.speedFromPreviousPointStr.length > 0 ? pItem.speedFromPreviousPointStr : '0 meter/hour'}</div>
                            </div>
                            <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 2px">
                                <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/map-pin.svg">
                                <div style="color: #737373; font-weight: bold">${pItem.address}</div>
                            </div>
                        </div>
                            `, {minWidth: 400, maxWidth: 800}
                    );
                this.markerLayerGroup.addLayer(marker);
            });

            // Draw arrows for this track
            for (let i = 0; i < currentCoOrdsList.length - 1; i++) {
                const startPoint = currentCoOrdsList[i];
                const endPoint = currentCoOrdsList[i + 1];
                const intermediatePoints = this.interpolatePoints(startPoint, endPoint);

                intermediatePoints.forEach((point, index) => {
                    const angle = this.calculateAngle(startPoint, point);

                    const icon = L.divIcon({
                        html: `<div style="transform: rotate(${angle}deg); margin: 0 5px">
                        <img src="/assets/icons/location-icons/arrow.svg" style="width: 10px; height: 10px;">
                     </div>`,
                        className: 'custom-icon',
                        iconSize: [10, 10]
                    });

                    const marker = L.marker(point, {icon: icon});
                    this.markerLayerGroup.addLayer(marker);
                });
            }
        });

        if (coOrdsList.length > 0) {
            const bounds = L.latLngBounds(coOrdsList);
            this.map.fitBounds(bounds, {padding: [50, 50], maxZoom: 7});
        } else {
            this.map.setView([23.8383283, 90.3759853], 7);
        }

        this.map.addLayer(this.polyLineLayer);
        this.map.addLayer(this.markerLayerGroup);
    }

    tabChangeListener(pTab: string): void {
        this.selectedTab = pTab;
        if (pTab === 'Map') {
            setTimeout(() => {
                if (this.map) {
                    this.map.invalidateSize();
                } else {
                    this.loadMapIfNeeded();
                }
            }, 100);
        }
    }

    viewEventModal(pTimeline: any): void {
        const modal = document.getElementById('viewEventModal');
        modal.style.display = 'block';
        const filters = {
            userId: this.filters.userId,
            imei: pTimeline.imei,
            date: pTimeline.date,
        };
        this.service.getEventList(filters, base_urls.p_base).subscribe(eventList => {
            this.eventList = eventList;
            if (this.eventList.points) {
                this.eventList.points = this.eventList.points.map(item => ({
                    ...item,
                    formattedTime: this.formatTime(item.dateTime)
                }));
            }
        });

    }

    formatTime(time: string): string {
        const [hours, minutes, seconds] = time.split(':').map(Number);

        const ampm = hours >= 12 ? 'PM' : 'AM';
        const h = hours % 12 || 12;

        const hh = h.toString().padStart(2, '0');
        const mm = minutes.toString().padStart(2, '0');
        const ss = seconds.toString().padStart(2, '0');

        return `${hh}:${mm}:${ss} ${ampm}`;
    }

    closeEventModal(): void {
        const modal = document.getElementById('viewEventModal');
        modal.style.display = 'none';
    }

    downloadReport(): void {
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="XLSX" id="input1" name="filetype" checked> XLSX' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="CSV" id="input2" style="margin-left: 20px;"> CSV ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                const isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                const isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                if (isSelected || isSelected1) {
                    swal.enableConfirmButton();
                } else {
                    swal.disableConfirmButton();
                }
                const fileName = (<HTMLInputElement>document.getElementById('report')).value;
                let fileType;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                const request = prepareObject({
                    ...this.filters,
                    imei: this.selectedImei
                });
                const exportRequest = {
                    downloadFileName: fileName ? fileName : 'User Timeline By Date Range',
                    fileType: fileType
                };
                const combinedRequest = {...request, ...exportRequest};
                this.service.generateAsyncPostUrlForMicroservice(base_urls.p_base + Endpoints.export_user_timeline_by_date_range, combinedRequest, null, false).subscribe(
                    data => {
                        swal('Message', data, 'success');
                    });
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }

}

